import { motion } from "framer-motion";
import { CarBody } from "./parts";

export const MiniCar = ({ className = "" }) => (
  <svg
    viewBox="0 0 240 130"
    className={className}
    data-testid="mini-car-illustration"
    role="img"
    aria-label="Cartoon blue learner car with an L plate"
  >
    <motion.g
      animate={{ y: [0, -4, 0] }}
      transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
    >
      <CarBody />
    </motion.g>
  </svg>
);
